
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    initProduct(section);
  });
});

function initProduct(section) {
  const variantsElement = section.querySelector('[data-product-variants]');

  if (!variantsElement) return;

  let variants = [];

  try {
    variants = JSON.parse(variantsElement.textContent);
  } catch (error) {
    console.error('Unable to parse product variants.', error);
    return;
  }

  const form = section.querySelector('[data-product-form]');
  const variantInput = section.querySelector('[data-variant-id]');

  const optionGroups = section.querySelectorAll('[data-product-option]');
  const optionButtons = section.querySelectorAll('[data-option-value]');

  const priceElement = section.querySelector('[data-product-price]');
  const comparePriceElement = section.querySelector(
    '[data-product-compare-price]'
  );

  const addToCartButton = section.querySelector('[data-add-to-cart]');
  const addToCartText = section.querySelector('[data-add-to-cart-text]');

  const unavailableMessage = section.querySelector(
    '[data-product-unavailable]'
  );

  const mainImage = section.querySelector('[data-product-main-image]');
  const thumbnails = section.querySelectorAll('[data-product-thumbnail]');

  const thumbnailTrack = section.querySelector(
    '[data-product-thumbnail-track]'
  );

  const thumbnailPrev = section.querySelector(
    '[data-thumbnail-prev]'
  );

  const thumbnailNext = section.querySelector(
    '[data-thumbnail-next]'
  );
  let selectedOptions = getSelectedOptions();

  /**
   * Get currently selected standard variant options.
   *
   * Connected-product options are ignored when resolving variants because
   * they point to another Shopify product.
   */
  function getSelectedOptions() {
    const selections = [];

    optionGroups.forEach((group) => {
      const selectedButton = group.querySelector(
        '[data-option-value][aria-pressed="true"]'
      );

      if (!selectedButton) return;

      const connectedProductUrl =
        selectedButton.dataset.connectedProductUrl;

      if (connectedProductUrl) return;

      const position =
        parseInt(selectedButton.dataset.optionPosition, 10) - 1;

      selections[position] = selectedButton.dataset.optionValue;
    });

    return selections;
  }

  /**
   * Find the Shopify variant matching the selected options.
   */
  function findVariant() {
    return variants.find((variant) => {
      return variant.options.every((variantOption, index) => {
        const selectedOption = selectedOptions[index];

        if (selectedOption === undefined) {
          return true;
        }

        return String(variantOption) === String(selectedOption);
      });
    });
  }

  /**
   * Update the product after selecting a variant option.
   */
  function updateProduct() {
    selectedOptions = getSelectedOptions();

    const variant = findVariant();

    if (!variant) {
      setUnavailableState();
      return;
    }

    if (variantInput) {
      variantInput.value = variant.id;

      /**
       * Let Shopify components know that the selected variant changed.
       * This can matter for dynamic checkout buttons.
       */
      variantInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }

    updatePrice(variant);
    updateAvailability(variant);
    updateVariantMedia(variant);
    updateUrl(variant);
  }

  /**
   * No valid variant exists for the current selection.
   */
  function setUnavailableState() {
    if (variantInput) {
      variantInput.value = '';
    }

    if (addToCartButton) {
      addToCartButton.disabled = true;
    }

    if (addToCartText) {
      addToCartText.textContent = 'Unavailable';
    }

    if (unavailableMessage) {
      unavailableMessage.textContent = 'Unavailable';
      unavailableMessage.classList.remove('hidden');
    }
  }

  /**
   * Update product price.
   */
  function updatePrice(variant) {
    if (priceElement) {
      priceElement.textContent = variant.priceFormatted;
    }

    if (!comparePriceElement) return;

    if (
      variant.compareAtPrice &&
      variant.compareAtPrice > variant.price
    ) {
      comparePriceElement.textContent =
        variant.compareAtPriceFormatted || '';

      comparePriceElement.classList.remove('hidden');
    } else {
      comparePriceElement.textContent = '';
      comparePriceElement.classList.add('hidden');
    }
  }

  /**
   * Update product availability.
   */
  function updateAvailability(variant) {
    if (variant.available) {
      if (addToCartButton) {
        addToCartButton.disabled = false;
      }

      if (addToCartText) {
        addToCartText.textContent = 'Add to Cart';
      }

      if (unavailableMessage) {
        unavailableMessage.classList.add('hidden');
      }
    } else {
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }

      if (addToCartText) {
        addToCartText.textContent = 'Sold Out';
      }

      if (unavailableMessage) {
        unavailableMessage.textContent = 'Sold Out';
        unavailableMessage.classList.remove('hidden');
      }
    }
  }

  /**
   * Replace the main product image.
   *
   * srcset and sizes are removed after the initial page load so the browser
   * cannot continue choosing an image belonging to the previous media item.
   */
  function setMainImage(src, alt = '') {
    if (!mainImage || !src) return;

    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');

    mainImage.src = src;

    if (alt) {
      mainImage.alt = alt;
    }
  }

  /**
   * Switch to variant-specific featured media when available.
   */
  function updateVariantMedia(variant) {
    if (!variant.featuredImage) return;

    setMainImage(
      variant.featuredImage,
      variant.featuredImageAlt || ''
    );

    if (variant.featuredMediaId) {
      setActiveThumbnail(variant.featuredMediaId);
    }
  }

  /**
   * Keep the Shopify ?variant= URL synchronized.
   */
  function updateUrl(variant) {
    const url = new URL(window.location.href);

    url.searchParams.set('variant', variant.id);

    window.history.replaceState({}, '', url);
  }

  /**
   * Update the active gallery thumbnail.
   */
  function setActiveThumbnail(mediaId) {
    thumbnails.forEach((thumbnail) => {
      const isActive =
        String(thumbnail.dataset.mediaId) === String(mediaId);

      thumbnail.classList.toggle(
        'border-[var(--theme-accent)]',
        isActive
      );

      thumbnail.classList.toggle(
        'border-[var(--theme-card-border)]',
        !isActive
      );

      thumbnail.classList.toggle(
        'opacity-70',
        !isActive
      );

      if (isActive) {
        thumbnail.setAttribute('aria-current', 'true');
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });
  }

  /**
   * Product option selection.
   */
  optionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const connectedProductUrl =
        button.dataset.connectedProductUrl;

      /**
       * Shopify Combined Listing.
       *
       * This option represents another product rather than a variant
       * belonging to the current product.
       */
      if (connectedProductUrl) {
        window.location.href = connectedProductUrl;
        return;
      }

      const group = button.closest('[data-product-option]');

      if (!group) return;

      group
        .querySelectorAll('[data-option-value]')
        .forEach((groupButton) => {
          const selected = groupButton === button;

          groupButton.setAttribute(
            'aria-pressed',
            selected ? 'true' : 'false'
          );

          groupButton.classList.toggle(
            'border-[var(--theme-accent)]',
            selected
          );

          groupButton.classList.toggle(
            'bg-[var(--theme-surface)]',
            selected
          );

          groupButton.classList.toggle(
            'text-[var(--theme-text)]',
            selected
          );

          groupButton.classList.toggle(
            'border-[var(--theme-border)]',
            !selected
          );

          groupButton.classList.toggle(
            'text-[var(--theme-text-muted)]',
            !selected
          );
        });

      updateProduct();
    });
  });

  /**
   * Thumbnail carousel navigation.
   */
  if (thumbnailTrack && thumbnailPrev && thumbnailNext) {
    const updateThumbnailArrows = () => {
      const maxScroll =
        thumbnailTrack.scrollWidth - thumbnailTrack.clientWidth;

      thumbnailPrev.disabled = thumbnailTrack.scrollLeft <= 1;

      thumbnailNext.disabled =
        thumbnailTrack.scrollLeft >= maxScroll - 1;
    };

    thumbnailPrev.addEventListener('click', () => {
      thumbnailTrack.scrollBy({
        left: -thumbnailTrack.clientWidth,
        behavior: 'smooth'
      });
    });

    thumbnailNext.addEventListener('click', () => {
      thumbnailTrack.scrollBy({
        left: thumbnailTrack.clientWidth,
        behavior: 'smooth'
      });
    });

    thumbnailTrack.addEventListener(
      'scroll',
      updateThumbnailArrows
    );

    updateThumbnailArrows();
  }

  /**
   * Gallery thumbnail selection.
   */
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const imageSrc = thumbnail.dataset.imageSrc;
      const imageAlt = thumbnail.dataset.imageAlt;

      setMainImage(imageSrc, imageAlt);

      setActiveThumbnail(thumbnail.dataset.mediaId);
    });
  });

  /**
   * Prevent submission without a valid Shopify variant.
   */
  if (form) {
    form.addEventListener('submit', (event) => {
      if (!variantInput || !variantInput.value) {
        event.preventDefault();
      }
    });
  }
}